var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("ul", { staticClass: "title-nav" }, [
      _c("li", [
        _c(
          "div",
          {
            staticClass: "back-btn",
            on: {
              click: function($event) {
                return _vm.routeBack()
              }
            }
          },
          [
            _c("i", { staticClass: "material-icons md-18" }, [
              _vm._v("keyboard_arrow_left")
            ])
          ]
        ),
        _vm._v(" "),
        _vm._m(0)
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "category" }, [
      _c("div", { staticClass: "category-title" }, [_vm._v("TEAM MEMBERS")]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _vm._v("\n\t\t\tteammember1@email.com\n\t\t\t"),
        _c(
          "a",
          {
            staticClass: "float-right text-secondary",
            attrs: { href: "javascript:" },
            on: { click: _vm.deleteShow }
          },
          [_vm._v("x")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "property-row" }, [
        _vm._v("\n\t\t\tteammember1@email.com\n\t\t\t"),
        _c("span", { staticClass: "badge badge-dark" }, [_vm._v("pending")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "float-right text-secondary",
            attrs: { href: "javascript:" },
            on: { click: _vm.deleteShow }
          },
          [_vm._v("x")]
        )
      ]),
      _vm._v(" "),
      _vm.mode == "view"
        ? _c("div", { staticClass: "property-row" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-light btn-sm float-right",
                on: { click: _vm.editShow }
              },
              [_vm._v("Add Member")]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.mode == "edit"
      ? _c(
          "form",
          {
            staticClass: "category form-group",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submitChange.apply(null, arguments)
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "category-title", attrs: { for: "signUpEmail" } },
              [_vm._v("ADD TEAM MEMBER")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "property-row" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newMemberEmail,
                    expression: "newMemberEmail"
                  }
                ],
                staticClass: "form-control",
                class: { "is-invalid": _vm.error },
                attrs: {
                  type: "email",
                  id: "email",
                  "aria-describedby": "emailHelp",
                  placeholder: "Enter team member email"
                },
                domProps: { value: _vm.newMemberEmail },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.newMemberEmail = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "invalid-feedback" }, [
                _vm._v("\n\t\t\t\t" + _vm._s(_vm.error) + "\n\t\t   ")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "property-row" }, [
              _c(
                "button",
                { staticClass: "btn btn-light", on: { click: _vm.editCancel } },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-dark float-right",
                  attrs: { type: "submit" }
                },
                [_vm._v("Send Invite")]
              )
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title-label" }, [
      _c("i", { staticClass: "material-icons md-18" }, [_vm._v("group")]),
      _vm._v(" TEAM")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33b2a9ff", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b2a9ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/agent/agent-team.vue
// module id = null
// module chunks = 